import { isMockMode, post, simulateDelay } from "../api";

export const registerToExistingOrg = (data) => {
	if (isMockMode()) {
		const testData = { isValid: true };

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/RegisterToExistingOrg`, data, {
		successMessage: "Subscription successfully registered",
	});
};
